import { render } from "./CalendarHeader.vue?vue&type=template&id=74d1968c"
import script from "./CalendarHeader.vue?vue&type=script&lang=js"
export * from "./CalendarHeader.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__